import { VStack } from '@chakra-ui/react';

export interface CallBigWindowPanelProps {
  children: React.ReactNode;
  frontChildren?: React.ReactNode;
  sideChildren: React.ReactNode;
}

export function CallMaxWindowPanel({
  children,
  frontChildren,
  sideChildren,
}: CallBigWindowPanelProps) {
  return (
    <VStack
      animationName="scale-in"
      animationDuration="moderate"
      id="callMaxWindowPanel"
      bg="grey.97"
      w="full"
      h="full"
      px="2.5"
      pt="2.5"
      pos="relative"
    >
      {frontChildren}
      {children}
      {sideChildren}
    </VStack>
  );
}
